import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getDeviceDetail, putDeviceDetail, getDevicegroupsTree } from '@blade-sxp/device-management-pass/api/index';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    input = '';
    groupIdvalue = '';
    groupTree = [];
    currIndex = 0;
    parentId = 0;
    groupId = '';
    canWrite = true;
    detailList = {};
    deviceName = '';
    position = '';
    deviceError = false;
    deviceId = '';
    gateWayConfig = {
        selected: 'NONE',
        options: [
            {
                value: 'NONE',
                label: this.$t('unknown')
            },
            {
                value: 'IN',
                label: this.$t('entrance')
            }, {
                value: 'OUT',
                label: this.$t('exit')
            }
        ]
    };
    getStatusInfo(status) {
        switch (status) {
            case 0:
                return 'offline';
            case 1:
                return 'online';
            case 2:
                return 'unusual';
            default:
                return 'unknow';
        }
    }
    created() {
        // this.getgroupTree(); // 设备组列表
        this.getTree();
    }
    mounted() {
        const query = this.$route.query;
        const { deviceId } = query;
        // this.getOtaDetail();
        this.deviceId = deviceId;
        if (this.deviceId) {
            this.getDeviceDetail(deviceId);
        }
    }
    getDeviceDetail(deviceId) {
        getDeviceDetail(deviceId).then((res) => {
            const extInfo = JSON.parse(res?.extInfo ?? '{}');
            this.detailList = res;
            this.groupIdvalue = res.groupName;
            this.groupId = res.groupId;
            this.deviceName = this.detailList.deviceName;
            this.position = this.detailList.position;
            this.gateWayConfig.selected = res?.direction ?? 'NONE';
        });
    }
    // handleRenderContent(h: Element, { node, data, store }: any) {
    //   if (data.level !== 0) {
    //     return (
    //       <div class="content-left-item" style="width:100%">
    //         <div class={{ 'item-active': (data.id as any) === this.currIndex }} ondblclick={($e: any) => this.handleOndbclick($e, data)}>
    //           {data.name}
    //         </div>
    //       </div>
    //     );
    //   }
    // }
    handleDragStart(node, $event) {
        this.$refs.tree.setCurrentKey(node.data.id);
        $event.dataTransfer.setData('drag', JSON.stringify(node.data));
    }
    handleDrag(node) {
        if (node.childNodes.length === 0) {
            return true;
        }
        return false;
    }
    handleOndbclick(event, data) {
        this.groupIdvalue = data?.name;
        this.groupId = data?.id;
        this.$refs.deviceOrganisation.handleClose();
    }
    putDeviceDetail() {
        let data = {
            deviceId: this.deviceId,
            groupId: this.groupId,
            name: this.deviceName,
            position: this.position,
            direction: this.gateWayConfig.selected
        };
        putDeviceDetail(this.deviceId, data).then((res) => {
            this.$message({ message: `${this.$t('editSuccess')}`, type: 'success' });
        });
    }
    handelBaseEdit() {
        this.canWrite = false;
    }
    handelBaseSubmit() {
        this.canWrite = true;
        this.putDeviceDetail();
    }
    handelCancel() {
        this.groupIdvalue = this.detailList.groupName;
        this.groupId = this.detailList.groupId;
        this.deviceName = this.detailList.deviceName;
        this.position = this.detailList.position;
        this.canWrite = true;
    }
    getTree() {
        let data = { keyword: '' };
        getDevicegroupsTree(data).then((res) => {
            if (res) {
                this.groupTree = res.tree;
            }
            else {
                this.groupTree = [];
            }
        });
    }
};
default_1 = __decorate([
    Component({
        components: { AuthItem },
        i18n: {
            messages: {
                'en-us': {
                    pleaseInput: 'Please input',
                    deviceError: 'Device error',
                    editSuccess: 'Successfully edited',
                    unknown: 'Unknown',
                    entrance: 'Entrance',
                    exit: 'Exit',
                    gateway: 'Gateway',
                },
                zh: {
                    pleaseInput: '请输入内容',
                    deviceError: '设备异常',
                    editSuccess: '修改成功',
                    unknown: '未知',
                    entrance: '入口',
                    exit: '出口',
                    gateway: 'Gateway',
                },
            },
        },
    })
], default_1);
export default default_1;
